import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { AudioPlayer } from './AudioPlayer';
const deliverables = ['Ebook "Dopamina Limpia": El protocolo paso a paso (Fase de Choque + Fase de Reconfiguración).', 'La Regla de los 3 Segundos: El framework para romper el ciclo automático de scroll.', 'Audio-Guía de Emergencia (Pista 1): Escucha esto cuando sientas que vas a rendir ante un estímulo barato.', 'Checklist "Dormitorio Cero": Cómo configurar tu entorno para que el éxito sea inevitable.', 'Hoja de Trabajo de Reemplazo: Cómo llenar el vacío del aburrimiento con actividades que construyan tu futuro.'];
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark px-4 py-16 md:py-24" data-id="element-131">
      <div className="max-w-5xl mx-auto" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="space-y-12" data-id="element-133">
          <h2 className="font-bebas text-4xl md:text-6xl text-white leading-tight" data-id="element-134">
            QUÉ OBTIENES
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start" data-id="element-135">
            <div className="space-y-6" data-id="element-136">
              {deliverables.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-137">
                  <CheckCircleIcon className="w-6 h-6 text-teal flex-shrink-0 mt-1" data-id="element-138" />
                  <p className="font-inter text-base text-text/80 leading-relaxed" data-id="element-139">
                    {item}
                  </p>
                </motion.div>)}

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {
              opacity: 0,
              y: 20
            }} transition={{
              duration: 0.6,
              delay: 0.5
            }} className="pt-4" data-id="element-140">
                <AudioPlayer src="https://cdn.magicpatterns.com/uploads/3K8TqjZvrYCuZsRtBYT18U/ElevenLabs_desecha_la_dopamina.mp3" title="Audio-Guía de Emergencia" data-id="element-141" />
              </motion.div>
            </div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="rounded-lg overflow-hidden border border-teal/20" data-id="element-142">
              <img src="https://cdn.magicpatterns.com/uploads/4VzUoqSzMLX34n1kFVfSiW/private_openrouter-generated-image-1774635100609.png" alt="Protocolo Dopamina Limpia - Reinicio 7 Días" className="w-full h-auto" data-id="element-143" />
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}